import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Store } from '@ngxs/store';

import { CustomerSubscription } from '@app/core/models/customer.models';
import { CustomerState } from '@app/core/store/states/customer/customer.state';
import { SubscriptionState } from '@app/core/store/states/customer/subscription/subscription.state';

@Component({
  standalone: false,
  selector: 'adspt-subscription-success',
  templateUrl: 'subscription-success.component.html',
  styleUrls: ['subscription-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionSuccessComponent {
  readonly subscription$: Observable<CustomerSubscription | undefined> = this.store.select(
    SubscriptionState.subscription,
  );

  readonly invoicesTabUrl$ = this.store
    .select(CustomerState.isAgency)
    .pipe(map((isAgency) => (isAgency ? '/settings/agency/invoices' : '/settings/customer/invoices')));

  constructor(private store: Store) {}
}
